import {User} from "@/model";

export default {
    state: {
        userFormData: {
            ...User
        },
        formError: []
    },
    mutations: {
        setUserFormData(state, payload) {
            state.userFormData = payload
        },
        setFormAttribute(state, key, value) {
            state.userFormData[key] = value;
        },
        setUserProfilePhotoUrl (state, payload) {
            state.userFormData.profilePhotoUrl = payload;
        },
        setUserStoryPhotoUrl (state, payload) {
            state.userFormData.storyPhotoUrl = payload;
        },
        setFormError (state, payload) {
            state.formError = payload;
        }
    },
    actions: {
        setUserFormData({commit}, payload) {
            commit('setUserFormData', payload);
        },
        setFormAttribute({commit}, key, value) {
            commit('setFormAttribute', key, value);
        },
        setUserProfilePhotoUrl({commit}, payload) {
            commit('setUserProfilePhotoUrl', payload);
        },
        setUserStoryPhotoUrl({commit}, payload) {
            commit('setUserStoryPhotoUrl', payload);
        },
        setFormError ({commit}, payload) {
            commit('setFormError', payload);
        }
    },
    getters: {
        userFormData (state) {
            return state.userFormData;
        },
        formError (state) {
            return state.formError;
        }

    }
}
